import { ProductContextBase } from '@app/baseBtl/context/child/product-context.service';
import { RenewContextServiceBase } from '@app/baseBtl/context/child/renew-context.service';
import { Rsf } from '@app/catalog/products/interface/phone';

import { ComplexBase } from '../complex';

export class GaletBase extends ComplexBase {
    protected updatePrice(): void {
        const renewContext: RenewContextServiceBase =
            this.context.contextService.get<RenewContextServiceBase>(RenewContextServiceBase);
        this.price = this.selectPrice();
        const rsf: Rsf = this.selectRsf(this.context, renewContext);
        let refund: number = this.price;
        let oldRefund: number = 0;
        let total: number = 0;
        if (!this.odr && !rsf) {
            return;
        } else {
            this.odrRsf = {};
        }
        if (this.odr) {
            refund = refund - this.odr.amount;
            oldRefund = this.oldPrice - this.odr.amount;
            oldRefund = oldRefund > 0 ? oldRefund : 1;
            total = Number(this.odr.amount);
            this.odrRsf.odr = this.odr;
        }
        if (rsf && !renewContext) {
            refund = refund - rsf.amount;
            total = rsf.amount + total;
            this.odrRsf.rsf = rsf;
        }
        if (refund < 0) {
            this.odrRsf.total = total + refund - 1;
        } else {
            this.odrRsf.total = total;
        }
        refund = refund > 0 ? refund : 1;

        this.odrRsf.refund = refund;
        this.odrRsf.oldRefund = oldRefund;
    }

    private selectPrice(): number {
        if (!this.prices && !this.specialPrice) {
            return 0;
        }
        let currentPrice: string;
        if (
            this.context.plan &&
            this.prices.plans &&
            this.prices.plans[this.context.plan] &&
            this.prices.plans[this.context.plan].acquisition.price
        ) {
            currentPrice = this.prices.plans[this.context.plan].acquisition.price;
        } else {
            currentPrice = this.prices.sowo.base_price;
        }
        return Number.parseFloat(currentPrice);
    }

    private selectRsf(productContextService: ProductContextBase, renewContext: RenewContextServiceBase): Rsf {
        if (!this.prices || renewContext) {
            return null;
        }
        let currentRsf: Rsf = null;

        const plans: any = this.prices.plans[productContextService.plan]
            ? this.prices.plans[productContextService.plan].acquisition
            : null;
        if (plans && plans.rsfAmount) {
            currentRsf = {
                amount: plans.rsfAmount,
                file: plans.rsfPdf,
            };
        }

        return currentRsf;
    }
}
